import { ModuleWithProviders, NgModule, inject } from '@angular/core';
import { ColorCalculationsService } from './color-calculation.service';

@NgModule()
export class ColorModule {
  constructor() {
    const module = inject(ColorModule, { optional: true, skipSelf: true });

    if (module) {
      throw new Error(`${ColorModule.name} should be imported only once!`);
    }
  }

  static forRoot(): ModuleWithProviders<ColorModule> {
    return {
      ngModule: ColorModule,
      providers: [ColorCalculationsService],
    };
  }
}
